import { casesActions } from "configs";
import { generateId, useCurrentCase, useDispatch, useParams } from "duck";
import { useCreateAnestheticGasAndOxygenMutation } from "requests";
import { FormValues } from "./types";

export const useCreateAnestheticGasAndOxygen = (patientId: number) => {
  const dispatch = useDispatch();
  const { id: caseId } = useParams();
  const [create] = useCreateAnestheticGasAndOxygenMutation();
  const shouldSync = useCurrentCase(medicalCase => medicalCase.shouldSync);

  return (values: FormValues) => {
    const variables = {
      timeMonitoring: values.timeMonitoring?.toISOString(),
      inhalantAnestheticAgent: values.inhalantAnestheticAgent,
      oxygen: values.oxygen
    };

    if (shouldSync) {
      return create({
        variables: {
          input: {
            patient: patientId,
            ...variables
          }
        }
      }).then(response => {
        const newAnestheticGas =
          response.data?.createAnestheticGas?.anestheticGas;
        if (newAnestheticGas) {
          dispatch(
            casesActions.addAnestheticGases({
              _id: caseId,
              data: newAnestheticGas
            })
          );
        }
      });
    }

    dispatch(
      casesActions.addAnestheticGases({
        _id: caseId,
        data: {
          fakeId: generateId(),
          ...variables
        }
      })
    );

    return Promise.resolve();
  };
};
